import { Controller } from "@hotwired/stimulus"

// The Sign in page's email field (TMS-1642). Submitting with an address that isn't one shows the
// error under the field and keeps the form on the page; fixing it clears the error as they type.
const EMAIL_PATTERN = /^[^@\s]+@[^@\s]+\.[^@\s]+$/
const MESSAGE = "Please enter a valid email address."

export default class extends Controller {
  static targets = ["input"]

  validate(event) {
    if (this.valid()) return

    event.preventDefault()
    this.showError()
    this.inputTarget.focus()
  }

  revalidate() {
    if (this.hasError() && this.valid()) this.clearError()
  }

  valid() {
    return EMAIL_PATTERN.test(this.inputTarget.value.trim())
  }

  showError() {
    const group = this.group()
    let hint = this.errorElement()

    if (!hint) {
      hint = document.createElement("div")
      hint.id = `${this.inputTarget.id}_error`
      hint.className = "app-input-hint is-error"
      hint.setAttribute("role", "alert")
      group.appendChild(hint)
    }
    hint.textContent = MESSAGE
    group.classList.add("has-error")
    this.inputTarget.setAttribute("aria-invalid", "true")
    this.inputTarget.setAttribute("aria-describedby", hint.id)
  }

  clearError() {
    this.errorElement()?.remove()
    this.group().classList.remove("has-error")
    this.inputTarget.removeAttribute("aria-invalid")
    this.inputTarget.removeAttribute("aria-describedby")
  }

  hasError() {
    return this.group().classList.contains("has-error")
  }

  group() {
    return this.inputTarget.closest(".app-input-group")
  }

  errorElement() {
    return document.getElementById(`${this.inputTarget.id}_error`)
  }
}
